import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducer from './reducers'
import './lib/Polyfill'
import 'whatwg-fetch'
import * as Sentry from '@sentry/browser'

import App from './containers/App'
import { composeWithDevTools } from 'redux-devtools-extension';

const middleware = window.Config.production ?
	[ thunk ] :
	[ thunk, createLogger() ]

const store = createStore(
	reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

/**
 * initialize sentry
 */
if(window.hasOwnProperty('Config') && window.Config.hasOwnProperty("frontSentry")){
  Sentry.init({
    dsn: window.Config.frontSentry,
    debug: true,
    release : "1.0.0"
  });
  Sentry.configureScope(scope => {
    scope.setExtra('Config', window.Config);
  });
}

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('cMain')
)
